export default "__VITE_ASSET__CJNxDfPM__"